import { Currency } from "../../shared";
import { Schema as S } from "effect";
export const Schema = S.Record({
    key: S.String,
    value: S.Struct({
        unit_amount: S.NullOr(Currency.Amount.AmountNumber.Schema),
        unit_amount_decimal: S.NullOr(Currency.Amount.AmountString.Schema)
    })
});
export const makeUnsafe = (productId)=>productId;
export const DecodedSchema = S.Record({
    key: Currency.Code.ISO4217.Schema,
    value: S.Struct({
        currency: Currency.Code.ISO4217.Schema,
        unitAmount: Currency.Amount.AmountString.Schema,
        presentmentUnitAmount: Currency.Amount.UnitAmount.Schema
    })
});
